/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

import ServicePath from "@/core/ServicePath"
import {
  MainRequest
} from "@/core/request";

export default class DownloadZipRequest extends MainRequest {


  static downloadImagesDCM(object) {
    return this.postPDFSEC(ServicePath.DOWNLOAD_IMAGES_DCM, object);
  }

  static downloadStudy(accessKey) {
    return this.getZipUN(ServicePath.DOWNLOAD_STUDY_ZIP+accessKey+"/dw09");
  }

  static downloadPDFDicom(object) {
    return this.postPDFSEC(ServicePath.DOWNLOAD_DICOM_PDF, object);
  }
//   static downloadImagesDCM(object) {
//     this.postPDFSEC(ServicePath.GET_REPORT_INTERPRETATION, object).then((response) => {
//       const url = URL.createObjectURL(new Blob([response.data], {
//         type: 'application/pdf'
//       }))
//       window.open(url);
//     });
//   }

  static downloadPatientFile(object) {
    return this.postPDFSEC(ServicePath.DOWNLOAD_PATIENT_FILE, object);
  }

  static downloadInterpretationFile(object) {
    return this.postPDFSEC(ServicePath.DOWNLOAD_INTERPRETATION_FILE, object);
  }
 
  static generateDownloadAccessKey(object) {
    return this.postSEC(ServicePath.GENERATE_DOWNLOAD_ACCESS_STUDY, object);
  }

}